import { Canvas, FabricImage, FabricObject, PencilBrush, Point } from "fabric";
import { FileType } from "operations/schema/schema";

/**
 * Place an object by its top-left corner.
 *
 * fabric v6+ centres objects on their `left`/`top` by default, and the
 * `originX`/`originY` properties that used to change that are deprecated.
 * `setXY` is the supported way to position by a different corner, and it
 * accounts for rotation and for text whose size depends on its content.
 */
export const placeAtTopLeft = (object: FabricObject, x: number, y: number) => {
  object.setXY(new Point(x, y), "left", "top");
  object.setCoords();
  return object;
};

export const initCanvas = (componentId: string, file: FileType | undefined) => {
  const canvas = new Canvas(componentId, {
    selectionBorderColor: "black",
    selectionColor: "black",
  });
  // fabric v6+ no longer creates a default brush, so drawing mode needs one.
  canvas.freeDrawingBrush = new PencilBrush(canvas);

  // Decoding an image is asynchronous, even for a data: URL. fabric v6+ reads
  // the element's dimensions when the FabricImage is constructed and only
  // paints on request, so the image has to be loaded before it is attached --
  // otherwise the background is sized 0x0 and nothing appears until some other
  // interaction happens to trigger a render.
  const data = file?.data;
  if (data) {
    FabricImage.fromURL(data)
      .then((image) => {
        if (canvas.disposed) return;
        canvas.setDimensions({ width: image.width, height: image.height });
        canvas.backgroundImage = placeAtTopLeft(image, 0, 0);
        canvas.requestRenderAll();
      })
      .catch(() => {
        // Leave the canvas blank if the photo cannot be decoded.
      });
  }

  return canvas;
};
